import { useContext, ref, Ref } from '@nuxtjs/composition-api';
import axios from 'axios';

interface UseCredits {
  getTotalCreditAmount: (userId: number) => Promise<void>;
  totalCreditAmount: Ref<number>;
}

export const useCredits = (): UseCredits => {
  const { $axios } = useContext();
  const totalCreditAmount = ref<number>(0);
  const getTotalCreditAmount = async (userId: number): Promise<void> => {
    try {
      const response = await $axios.get(`/private/v1/payment/accounts/${userId}/credits`);
      totalCreditAmount.value = response?.data?.totalCreditAmount || 0;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status && error.response?.status > 404) {
          console.error(error.response?.data?.message || error);
        }
      } else {
        console.error(error);
      }
      totalCreditAmount.value = 0;
    }
  };
  return {
    getTotalCreditAmount,
    totalCreditAmount,
  };
};
